export default {"src":"/_next/static/media/playstore.75d18d09.svg","height":40,"width":146,"blurWidth":0,"blurHeight":0};